import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { ICoverageIterationState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const coverageIterationModule: Module<ICoverageIterationState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default coverageIterationModule